import { AxiosInstance } from 'axios';
import { LogService } from 'services/LogService';
import { notify } from 'services/NotificationService';
import { Result } from 'services/Result';

export class CustomerCSVConfigurationService {
  axiosInstance: AxiosInstance;
  logService: LogService;

  constructor(axiosInstance: AxiosInstance, logService: LogService) {
    this.axiosInstance = axiosInstance;
    this.logService = logService;
  }

  fetchConfiguration = async () => {
    try {
      const response = await this.axiosInstance.get<Result<string[]>>('api/customerCSVConfiguration/configuration');
      if (response.data.data) {
        return response.data.data;
      }

      return [];
    } catch (error: unknown) {
      if (error instanceof Error) {
        this.logService.logError('Failed to fetch customer CSV configuration', error);
      }
      notify('Error', 'Failed to fetch customer CSV configuration', 'error');
      return [];
    }
  };
}
